var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgICamera({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58_7297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1363 4.9367H13.3181L12.809 4.06397C12.5726 3.65488 12.1363 3.40942 11.6726 3.40942H8.32718C7.85446 3.40942 7.42718 3.65488 7.19082 4.06397L6.68173 4.9367H3.86355C2.609 4.9367 1.59082 5.95488 1.59082 7.20942V14.3185C1.59082 15.5731 2.609 16.5912 3.86355 16.5912H16.1363C17.3908 16.5912 18.409 15.5731 18.409 14.3185V7.20942C18.409 5.95488 17.3908 4.9367 16.1363 4.9367Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 13.8548C11.8077 13.8548 13.273 12.3895 13.273 10.5821C13.273 8.77458 11.8077 7.30933 10.0003 7.30933C8.19279 7.30933 6.72754 8.77458 6.72754 10.5821C6.72754 12.3895 8.19279 13.8548 10.0003 13.8548Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7 8.44573C16.2172 8.44573 16.6364 8.0265 16.6364 7.50936C16.6364 6.99222 16.2172 6.573 15.7 6.573C15.1829 6.573 14.7637 6.99222 14.7637 7.50936C14.7637 8.0265 15.1829 8.44573 15.7 8.44573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.61884 3.89111H3.62793V4.94566H5.61884V3.89111Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8512 2.07451L19.5211 2.1594C18.8099 2.34426 18.2534 2.90073 18.0686 3.61188L17.9837 3.94199C17.9629 4.01933 17.8554 4.01933 17.8347 3.94199L17.7498 3.61188C17.5649 2.90073 17.0084 2.34426 16.2973 2.1594L15.9672 2.07451C15.8898 2.05376 15.8898 1.94624 15.9672 1.92549L16.2973 1.8406C17.0084 1.65574 17.5649 1.09927 17.7498 0.388116L17.8347 0.0580052C17.8554 -0.0193351 17.9629 -0.0193351 17.9837 0.0580052L18.0686 0.388116C18.2534 1.09927 18.8099 1.65574 19.5211 1.8406L19.8512 1.92549C19.9285 1.94624 19.9285 2.05376 19.8512 2.07451Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58_7297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1818,
    height: 14.5455,
    fill: "white",
    transform: "translate(0.90918 2.72729)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgICamera);
export default __webpack_public_path__ + "static/media/i_camera.d4c27381eb6c201a4c1db4d1e2985e94.svg";
export { ForwardRef as ReactComponent };